import React from 'react';
import Track from "../Track/Track";
import './TrackList.css';

function TrackList({tracks, onAdd, isRemoveable, onRemove}) {

    return(
        <div className="TrackList">
            {tracks.map(track => (
            <Track key={track.id} track={track} onAdd={onAdd} isRemoveable={isRemoveable} onRemove={onRemove}  />
            ))}
        </div>
    );
}

export default TrackList;